export enum ContainersMap {
  BILLING_QUEUE = "billing",
  RECEIPT_CUSTOMISATION = "receipt_config",
  NEW_APPOINTMENT_DASHBOARD = "new_appt_id",
  GLOBAL_SEARCH_APPT = "GLOBAL_SEARCH_APPT",
  HPR_HFR_ONBOARDING = "hpr_hfr_onboarding",
  MANAGE_TREATMENTS_CONTAINER_ID = "MANAGE_TREATMENTS_CONTAINER_ID",
  CURRENT_TREATMENT_CONTAINER_ID = "CURRENT_TREATMENT_CONTAINER_ID",
  MANAGE_SERVICES_CONTAINER_ID = "MANAGE_SERVICES_CONTAINER_ID",
  APPOINTMENT_CONFIGS_CONTAINER_ID = "APPOINTMENT_CONFIGS_CONTAINER_ID",
}

export const MH_POPUP_CONTAINER_ID = "mh-popup-container";

export const QUEUE_CONFIG_KEY = "queue-conf";
